import * as preregisterApplicantsTypes from './preregisterApplicantsTypes';

const initialState = {
    dropdownimport: {
      selectTypeofimport: [],
    },
  };
  
  const preregisterApplicantsReducer = (state = initialState, action) => {
    switch (action.type) {
      case preregisterApplicantsTypes.TYPE_OF_IMPORT:
        return {
          ...state,
          dropdownimport: action.payload,
        };
      default:
        return state;
    }
  };
  
  export { initialState };
  export default preregisterApplicantsReducer;
  


// WEBPACK FOOTER //
// ./src/ui/features/PreregisterApplicants/state/preregisterApplicantsReducer.js